/** Colunas do order by da pesquisa dos títulos a receber */
export enum TituloReceberSearchOrderBy {
    NumeroErp = 1,
    DataEmissao = 2,
    DataVencimento = 3,
    DataUltimoPagamento = 4,
    Valor = 5,
    ValorPago = 6,
    ValorJuros = 7,
    ValorSaldo = 8,
    SumValor = 9,
    SumValorPago = 10,
    SumValorJuros = 11,
    SumValorSaldo = 12,
    Pessoa = 13,
    Representante = 14,
    Situacao = 15,
    DataAtualizacaoFinanceira = 16,
    ValorRenegociado = 17,
    ValorAdimplencia = 18,
    PercAdimplencia = 19
};
